"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MonthlySavingsPanelState = /** @class */ (function () {
    function MonthlySavingsPanelState() {
        this.showMonthlySavingsModal = false;
    }
    return MonthlySavingsPanelState;
}());
exports.default = MonthlySavingsPanelState;
//# sourceMappingURL=MonthlySavingsPanelState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/MonthlySavingsPanel/MonthlySavingsPanelState.js
// module id = 2260
// module chunks = 8